import React, { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import EventController, {
  EventUserType,
} from "../../controller/EventController";
import LogController from "../../controller/LogController";
import { useToast } from "../../controller/ToastController";
import { authState } from "../../recoil/auth";
import { eventState, EventStateType } from "../../recoil/event";
import { LANG_KO, langState, langText } from "../../recoil/lang";
import moment from "../../utils/moment";
import { getRecoil, resetRecoil } from "recoil-nexus";
import ApiController from "../../controller/ApiController";
import { useQueryClient } from "@tanstack/react-query";

const RouletteEvent = (oProps: any) => {
  const queryClient = useQueryClient();

  const auth = useRecoilValue(authState);
  const currentDate = new Date();
  const hoursToAdd = 12;
  const futureDate = new Date(
    currentDate.getTime() + hoursToAdd * 60 * 60 * 1000
  );
  const showToast = useToast();
  const [rotation, setRotation] = useState(0);
  const [resultImage, setResultImage] = useState("");
  const [couponView, setCouponView] = useState<boolean>(false);
  const [nextTime, setNextTime] = useState<boolean>(false);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const [event, setEvent] = useRecoilState<EventStateType>(eventState);

  const handleStartRotateClick = async () => {
    if (isButtonDisabled) return;
    setIsButtonDisabled(true);

    await getEventCoupon(oProps);

    setTimeout(() => {
      setCouponView(true);
    }, 5000);
  };

  const getEventCoupon = async (oProps: EventUserType) => {
    try {
      if (event.event_id) {
        const response = await ApiController.store.setEventCoupon(
          event.event_id,
          getRecoil(authState).user_id,
          getRecoil(authState).user_token_id
        );

        if (response && response.data) {
          let prize = response.data.coupon_id;
          let degrees = 0;
          let resultImgSrc = "";
          let resultText = "";

          if (prize === 12) {
            degrees = 0;
            resultImgSrc = `https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/coupon01.png`;
            resultText = "2000원 당첨";
          } else if (prize === 15) {
            degrees = 45;
            resultImgSrc = `${process.env.PUBLIC_URL}/knockknock/img/event/coupon04.png`;
            resultText = "매장 50%할인 쿠폰 당첨";
          } else if (prize === 13) {
            degrees = 90;
            resultImgSrc = `https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/coupon02.png`;
            resultText = "3000원 당첨";
          } else if (prize === 14) {
            degrees = 315;
            resultImgSrc = `https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/coupon03.png`;
            resultText = "5000원 당첨";
          } else {
            setNextTime(true);
            resultImgSrc = `${process.env.PUBLIC_URL}/knockknock/img/event/nextTime.png`;
            resultText = "12시간 후 재도전";
          }

          console.log("authState", authState);
          setResultImage(resultImgSrc);
          const finalRotation = 360 * 8 + degrees;
          setRotation(finalRotation);

          LogController.click({
            path: "Roulette",
            params: "event",
            params2: resultText + " prize: " + prize + "룰렛 클릭",
            index: event.event_id,
          });

          await queryClient.fetchQuery({
            queryKey: ["store-list"],
            queryFn: () =>
              ApiController.store
                .getKnockMain(auth.user_id, auth.user_token_id)
                .then((res) => res.data),
          });
        }
      }
    } catch (err) {
      console.log("roulette err-->", err);
    }
  };

  const closeEvent = () => {
    // oProps.resetPage();
    // oProps.setEventView(false);
    // oProps.setEventViewTrueCount(0);
    resetRecoil(eventState);
    showToast(`${langText.event_notice[lang]}`, "success", 3000);
  };

  return (
    <Style>
      <div className="rouletteWrapper">
        {couponView && (
          <div className="resultLayer">
            <div className="resultCard">
              <img className="resultMoalImg" src={resultImage} alt="당첨모달" />

              <button onClick={closeEvent}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/img/event/closeButton.png`}
                  className="closeModalButton"
                  alt="모달닫기버튼"
                />
              </button>
              <div className="closeLayer">
                {!nextTime && (
                  <p className="dateNoticeText">
                    {lang === LANG_KO ? "" : langText.roulette_coupon[lang]}
                    {moment(futureDate).format("YYYY/MM/DD HH시 mm분")}
                    {lang === LANG_KO ? langText.roulette_coupon[lang] : ""}
                  </p>
                )}
                <button onClick={closeEvent}>
                  <h2 className="submitText">
                    {langText.button_confirm[lang]}
                  </h2>
                </button>
              </div>
            </div>
          </div>
        )}
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/img/event/roulette.png`}
          className="rouletteGift"
          alt="스루 행운 룰렛판"
          style={{
            transform: `translateX(-50%) rotate(${rotation}deg)`,
            transition: "transform 5s ease-in-out",
          }}
        />
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/img/event/arrow.png`}
          className="rouletteNiddle"
          alt="당첨 표시 화살표"
        />
        <button
          id="start-rotate"
          className="startrouletteStartBtnRotate"
          onClick={handleStartRotateClick}
          disabled={isButtonDisabled}
        >
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/img/event/startButton.png`}
            className="rouletteStartBtn"
            alt="룰렛돌리기버튼"
          />
        </button>
      </div>
    </Style>
  );
};
export default RouletteEvent;

const Style = styled.div`
  .rouletteWrapper {
    width: 95vw;
    height: 95vh;
    border-radius: 20px;
    background-image: url("/knockknock/img/event/backgroundImage.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  .rouletteGift {
    width: 80vw;
    position: absolute;
    bottom: 8%;
    left: 50%;
  }
  .rouletteNiddle {
    position: absolute;
    width: 10vw;
    bottom: 79vw;
    left: 50%;
    transform: translateX(-50%);
  }
  .rouletteStartBtn {
    position: absolute;
    width: 14vw;
    left: 50%;
    bottom: calc(33vw + 8%);
    transform: translateX(-50%);
  }

  .resultLayer {
    position: absolute;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.2);
    z-index: 100;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;

    .resultCard {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .resultMoalImg {
      position: relative;
      left: 3%;
      width: 100%;
      height: 500px;
    }
    .closeModalButton {
      position: absolute;
      right: 10%;
      top: 6%;
      width: 36px;
    }
    .closeLayer {
      position: absolute;
      width: 80%;
      left: 50%;
      bottom: 10%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      p {
        color: #979797;
        font-weight: 600;
      }
      button {
        width: 100%;
        background-color: #ff4588;
        padding: 16px 0 14px 0;
        border-radius: 20px;
        margin-bottom: auto;
        margin-top: 16px;

        h2 {
          color: #fff;
          font-family: "yg-jalnan";
          font-size: 30px;
          font-weight: 400;
          line-height: 38px;
        }
      }
    }
  }
`;
